import Stack from '@mui/material/Stack'
import { useEffect, useState } from 'react'
import { useGlobalContext } from '../../Contexts/GlobalContext'
import AnalysisIcon from '../icons/analysis'
import BurgerIcon from '../icons/burger'
import DailyPuzzleIcon from '../icons/daily_puzzle'
import HomeIcon from '../icons/home'
import LeaderboardIcon from '../icons/leaderboard'
import LiveGamesIcon from '../icons/live_games'
import MembershipsIcon from '../icons/memberships'
import PlayIcon from '../icons/play'
import PlayBotsIcon from '../icons/play_bots'
import PuzzleIcon from '../icons/puzzle'
import { PuzzleQuestIcon } from '../icons/puzzle-quest'
import UpdatesIcon from '../icons/updates'
import { IAppConfig, getAppConfig } from '../services/AppConfigService'
import { colors } from '../theme/colors'
import Dropdown, { DropdownMenuItem } from './Dropdown'

export type BurgerNavigationProps = {
    Link: any
}

const BurgerNavigation = (props: BurgerNavigationProps) => {
    const { Link } = props
    const { websiteURL, playAreaURL, userData } = useGlobalContext()
    const [appConfig, setAppConfig] = useState<IAppConfig | null>(null)

    useEffect(() => {
        const config = getAppConfig()
        setAppConfig(config)
    }, [])

    let burgerDropdownItems: DropdownMenuItem[] = [
        !!appConfig?.isMobileApp
            ? {
                  key: 'mainMenu',
                  link: `${playAreaURL}/?drawer=menu`,
                  title: 'Main menu',
                  icon: <HomeIcon />,
              }
            : {
                  key: 'home',
                  link: `${websiteURL}/`,
                  title: 'Home',
                  icon: <HomeIcon />,
              },
        {
            key: 'play',
            link: `${playAreaURL}/?drawer=game`,
            title: 'Play now',
            icon: <PlayIcon />,
        },
        {
            key: 'dailyPuzzle',
            link: `${playAreaURL}/daily-puzzle`,
            title: 'Daily puzzle',
            icon: <DailyPuzzleIcon />,
        },
        {
            key: 'puzzleQuest',
            link: `${playAreaURL}/puzzle-quest`,
            title: 'Puzzle Quest',
            icon: <PuzzleQuestIcon />,
        },
        {
            key: 'puzzles',
            link: `${playAreaURL}/puzzles`,
            title: 'Puzzle Practice',
            icon: <PuzzleIcon />,
        },
        {
            key: 'play bots',
            link: `${playAreaURL}/?drawer=bots`,
            title: 'Play bots',
            icon: <PlayBotsIcon />,
        },
        {
            key: 'watch',
            link: `${playAreaURL}/watch`,
            title: 'Watch Games',
            icon: <LiveGamesIcon />,
        },
        {
            key: 'analysis',
            link: `${playAreaURL}/analysis`,
            title: 'Analysis',
            icon: <AnalysisIcon />,
        },
        ...(!!appConfig?.isMobileApp
            ? [
                  {
                      key: 'what-is-new',
                      link: `${websiteURL}/`,
                      title: "What's New",
                      icon: <UpdatesIcon />,
                  },
              ]
            : []),
        {
            key: 'leaderboard',
            link: `${websiteURL}/leaderboard`,
            title: 'Leaderboard',
            icon: <LeaderboardIcon />,
        },
        ...(!!appConfig?.hideMemberships
            ? []
            : [
                  {
                      key: 'memberships',
                      link: `${websiteURL}/memberships`,
                      title: 'Memberships',
                      icon: <MembershipsIcon />,
                  },
              ]),
    ].map((item) => {
        // @ts-ignore wrong types evaluation
        return { ...(item as DropdownMenuItem), new: userData?.newContent?.[item.key || ''] || false }
    })

    return (
        <Stack
            direction="row"
            sx={{
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Dropdown
                Link={Link}
                menuButtonTitle={
                    <Stack
                        direction="row"
                        sx={{
                            alignItems: 'center',
                            justifyContent: 'center',
                            position: 'relative',
                            svg: {
                                zIndex: 1401,
                            },
                            '::after': {
                                // @ts-ignore wrong types evaluation
                                display: burgerDropdownItems.some((item) => userData?.newContent?.[item.key || ''])
                                    ? 'block'
                                    : 'none',
                                content: "''",
                                zIndex: 1401,
                                position: 'absolute',
                                top: '-1px',
                                right: '-4px',
                                width: '12px',
                                height: '12px',
                                borderRadius: '50%',
                                backgroundColor: colors.lightRed,
                            },
                        }}
                    >
                        <BurgerIcon />
                    </Stack>
                }
                dropdownItems={burgerDropdownItems}
            />
        </Stack>
    )
}
export default BurgerNavigation
